import { Resolution } from './types';

export function ceiling(number: number, significance: number = 0) {
  return Math.ceil(number / significance) * significance;
}

/**
 * Rounds resolution values up to the nearest significance
 * @param resolution - The resolution to ceiling
 * @param significance - The significance to round to (optional)
 * @returns New resolution with ceiling values
 */
export const ceilingResolutionValues = (
  resolution: Resolution,
  significance?: number
): Resolution => {
  return {
    width: ceiling(resolution.width, significance),
    height: ceiling(resolution.height, significance),
  };
};
